
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Tooltip41873227",
      {"classes":{"root":"Tooltip41873227__root","arrow":"Tooltip41873227__arrow","contentContainer":"Tooltip41873227__contentContainer"},"vars":{"arrow-color":"--Popover73845375-arrow-color"},"stVars":{"arrow-size":"9px","hover-margin":"6px","min-tooltip-width":"36px","max-tooltip-width":"264px"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  